// extracted by mini-css-extract-plugin
export default {"container":"CategoryEditModal_container__L8c4F","colorInput":"CategoryEditModal_colorInput__p39Cz","colorField":"CategoryEditModal_colorField__JWtJc"};